import "../../styles/profile_details.css";
import parseHtml from 'html-react-parser';

const Biography = ({ bio }) => {
    return (
        <div className="biography">
            <div className="b-header">
                Biography
            </div>
            <div className="b-details">
                {  
                    bio? bio.includes("</")? parseHtml(bio) : bio : "-"
                }
            </div>
        </div>
    )
}

export default Biography;